/**
 * The most companies each action takes at once. Bookmark, Add to workspace and
 * Request contacts mirror Search Companies, which disables them past 100 selected
 * ("Please select upto 100 companies"); contacts is held to 50 here, the cap the
 * contacts card already applies. Download of ticked companies matches the backend's
 * own cap on a company selection (MAX_SELECTED_COMPANIES).
 */
export type LimitedAction = "bookmark" | "workspace" | "contacts" | "download";

export const ACTION_LIMITS: Record<LimitedAction, number> = {
  bookmark: 100,
  workspace: 100,
  contacts: 50,
  download: 1000,
};

const ACTION_LABELS: Record<LimitedAction, string> = {
  bookmark: "Bookmark",
  workspace: "Add to workspace",
  contacts: "Request contacts",
  download: "Download",
};

/** Tooltip for an action that is over its limit for `count` companies; undefined when it is within it. */
export function overLimitMessage(action: LimitedAction, count: number): string | undefined {
  const limit = ACTION_LIMITS[action];
  return count > limit ? `${ACTION_LABELS[action]} works on up to ${limit.toLocaleString()} companies at a time (currently ${count.toLocaleString()}).` : undefined;
}
